// Site Configuration
export const SITE_URL = process.env.SITE_URL || 'https://esplastering.com';

// Business Information
export const BUSINESS_INFO = {
  name: 'Erroll Scheurer Plastering',
  phone: '(307) 277-3741',
  phoneRaw: '3072773741',
  email: 'ewilli40@yahoo.com',
  address: {
    street: '6325 Dream Catcher Dr',
    city: 'Casper',
    state: 'WY',
    zip: '82601',
    full: '6325 Dream Catcher Dr, Casper, WY 82601',
  },
  hours: {
    monday: '8:00 AM – 5:00 PM',
    tuesday: '8:00 AM – 5:00 PM',
    wednesday: '8:00 AM – 5:00 PM',
    thursday: '8:00 AM – 5:00 PM',
    friday: '8:00 AM – 5:00 PM',
    saturday: 'Closed',
    sunday: 'Closed',
  },
  license: {
    number: '(pending)',
    state: 'WY',
    type: 'WY CCRB',
    status: 'Fully Licensed, Bonded & Insured',
  },
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=61561994631883',
  },
  serviceRadius: 'Serving Casper, WY and all surrounding regions',
  serviceArea: 'Casper, WY and surrounding regions',
  paymentMethods: ['Cash', "Cashier's Checks", 'Money Orders'],
};

export type Service = {
  slug: string;
  name: string;
  short: string;
  description: string;
};

export const SERVICES: Service[] = [
  {
    slug: 'stucco-repair',
    name: 'Stucco Repair',
    short: 'Cracks, patches, water damage',
    description:
      'Professional stucco repair for cracks, holes, and water damage. We match textures and finishes for seamless results across exterior surfaces.',
  },
  {
    slug: 'plaster-installation',
    name: 'Plaster Installation',
    short: 'Interior plaster walls & ceilings',
    description:
      'Traditional and modern plaster installation for walls and ceilings. Smooth, durable finishes applied by experienced plastering craftsmen.',
  },
  {
    slug: 'lath-work',
    name: 'Lath Work',
    short: 'Metal/wood lath preparation',
    description:
      'Substrate preparation with metal or wood lath to support stucco and plaster systems, ensuring long-lasting adhesion and performance.',
  },
  {
    slug: 'texture-matching',
    name: 'Texture Matching',
    short: 'Seamless finish blending',
    description:
      'Perfect texture matching for repairs and remodels. We blend finishes to match existing knockdown, orange peel, smooth, or custom textures.',
  },
  {
    slug: 'drywall-repair',
    name: 'Drywall Repair',
    short: 'Holes, cracks, water damage',
    description:
      'Expert drywall repair for holes, cracks, and water damage. Clean patches, proper taping, and finishing for invisible repairs.',
  },
  {
    slug: 'drywall-installation',
    name: 'Drywall Installation',
    short: 'New installs, mudding, taping',
    description:
      'Full-service drywall installation including hanging, mudding, taping, and finishing for residential and light commercial projects.',
  },
];

// Service Areas organized by distance tiers (Casper, WY base)
// Immediate: 0–15 miles
export const SERVICE_AREAS_IMMEDIATE = [
  { slug: 'casper-wy', name: 'Casper, WY', distance: '0-15 miles' },
  { slug: 'evansville-wy', name: 'Evansville, WY', distance: '0-15 miles' },
  { slug: 'mills-wy', name: 'Mills, WY', distance: '0-15 miles' },
  { slug: 'bar-nunn-wy', name: 'Bar Nunn, WY', distance: '0-15 miles' },
  { slug: 'midwest-wy', name: 'Midwest, WY', distance: '0-15 miles' },
  { slug: 'alcova-wy', name: 'Alcova, WY', distance: '0-15 miles' },
  { slug: 'powder-river-wy', name: 'Powder River, WY', distance: '0-15 miles' },
];

// Secondary: 15–35 miles
export const SERVICE_AREAS_SECONDARY = [
  { slug: 'natrona-wy', name: 'Natrona, WY', distance: '15-35 miles' },
  { slug: 'willow-creek-wy', name: 'Willow Creek, WY', distance: '15-35 miles' },
  { slug: 'arminto-wy', name: 'Arminto, WY', distance: '15-35 miles' },
  { slug: 'lysite-wy', name: 'Lysite, WY', distance: '15-35 miles' },
  { slug: 'moneta-wy', name: 'Moneta, WY', distance: '15-35 miles' },
  { slug: 'medicine-bow-wy', name: 'Medicine Bow, WY', distance: '15-35 miles' },
  { slug: 'shirley-basin-wy', name: 'Shirley Basin, WY', distance: '15-35 miles' },
];

// Extended: 35–75 miles
export const SERVICE_AREAS_EXTENDED = [
  { slug: 'glenrock-wy', name: 'Glenrock, WY', distance: '35-75 miles' },
  { slug: 'douglas-wy', name: 'Douglas, WY', distance: '35-75 miles' },
  { slug: 'esterbrook-wy', name: 'Esterbrook, WY', distance: '35-75 miles' },
  { slug: 'ft-laramie-wy', name: 'Ft. Laramie, WY', distance: '35-75 miles' },
  { slug: 'wheatland-wy', name: 'Wheatland, WY', distance: '35-75 miles' },
  { slug: 'riverton-wy', name: 'Riverton, WY', distance: '35-75 miles' },
  { slug: 'shoshoni-wy', name: 'Shoshoni, WY', distance: '35-75 miles' },
  { slug: 'thermopolis-wy', name: 'Thermopolis, WY', distance: '35-75 miles' },
  { slug: 'hells-half-acre-wy', name: "Hell's Half Acre, WY", distance: '35-75 miles' },
];

export const SERVICE_AREAS = [
  ...SERVICE_AREAS_IMMEDIATE,
  ...SERVICE_AREAS_SECONDARY,
  ...SERVICE_AREAS_EXTENDED,
];

export const TESTIMONIALS: { quote: string; name: string; location: string }[] = [];
